import styled from '@emotion/styled';
import { SentenceSubmissionIndexWrapper } from '@seedlang/hoc';
import { LanguageIcon } from '@seedlang/icons';
import { AppUI } from '@seedlang/state';
import { flexCenterColumn } from '@seedlang/style_mixins';
import Paginator from 'components/paginator';
import Text from 'components/text';
import { observer } from 'mobx-react';
import React from 'react';

const Wrapper = styled.div`
  margin-top: 10px;
  border-top: ${props => props.showTopBorder ? '1px solid #CCC' : ''};
`;

const Table = styled.div`
  border-radius: 5px;
  ${flexCenterColumn()}
  h3 {
    width: 100%;
  }
`;

const SentenceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  cursor: pointer;
  padding: 10px;
  &:hover {
    background: #ECECEC;
  }
`;

const SentenceRow = styled.div`
  display: flex;
  flex-direction: ${props => props.flexDirection};
  width: 100%;
  border-bottom: 1px solid #CCC;
`;

const TextWrapper = styled.div`
  margin: ${props => props.margin};
  display: flex;
`;

const LanguageIconWrapper = styled.div`
  margin: ${props => props.margin};
  width: ${props => props.width};
`;

const RetiredNote = styled.div`
  color: #777;
  font-size: 12px;
  font-style: italic;
  line-height: 17px;
  padding: 10px 0 0;
  text-align: center;
`;

@observer
class SentenceSubmissionIndex extends React.Component {

  render() {
    return (
      <Wrapper showTopBorder={this.props.showTopBorder}>
        {
          AppUI.sentenceSubmissionStore.hasIndexData &&
            <Table>
              <h3>My Submissions</h3>
              {
                AppUI.sentenceSubmissionStore.indexData.map(item => {
                  return (
                    <SentenceRow
                      key={item.id}
                      flexDirection={AppUI.layout.isMobile ? 'column' : 'row'}
                    >
                      <SentenceWrapper>
                        <TextWrapper
                          margin='0 0 3px 0'
                        >
                          <LanguageIconWrapper
                            margin='3px 0'
                            width='25px'
                          >
                            <LanguageIcon
                              languageId={item.targetLanguage}
                            />
                          </LanguageIconWrapper>
                          <Text textAlign='left' margin='0 0 0 10px'>{item.targetText}</Text>
                        </TextWrapper>
                        <TextWrapper>
                          <LanguageIconWrapper
                            margin='3px 0'
                            width='25px'
                          >
                            <LanguageIcon
                              languageId={item.sourceLanguage}
                              user={AppUI.user}
                            />
                          </LanguageIconWrapper>
                          <Text textAlign='left' margin='0 0 0 10px'>{item.sourceText}</Text>
                        </TextWrapper>
                      </SentenceWrapper>
                    </SentenceRow>
                  );
                })
              }
              <RetiredNote>
                Thanks for adding these. Sentence submissions are retired now, so please use notes for new examples.
              </RetiredNote>
            </Table>
        }
        {
          (AppUI.sentenceSubmissionStore.page > 1 || AppUI.sentenceSubmissionStore.indexData.length >= 10) &&
            <Paginator
              store={AppUI.sentenceSubmissionStore}
            />
        }
      </Wrapper>
    );
  }
}

export default SentenceSubmissionIndexWrapper(SentenceSubmissionIndex);
